<template>
  <div class="holdActivity">
    <index-title titleText="我要办活动"></index-title>
    <div class="process">
      <el-row :gutter="10">
        <el-col :span="14">
          <div class="grid-content bg-purple">
            <el-row :gutter="10">
              <el-col :span="8" >
                <div class="proBox" @click="open(1)" @mouseenter="mouseEnter(1)" @mouseleave="mouseLeave(1)">
                  <div class="grid-content proCenter">
                    <img v-if="img1" src="@/assets/images/pro1-1.png"/>
                    <img v-else src="@/assets/images/pro1-2.png"/>
                    <p class="title">素材库制作图片素材</p>
                    <p class="details" title="活动云平台内置强大的可视化图片编辑器，助力机构快速设计出需要的设计稿，通过替换修改文字就能够完成图片设计。">活动云平台内置强大的可视化图片编辑器，助力机构快速设计出需要的设计稿，通过替换修改文字就能够完成图片设计。</p>
                    <div class="lookIcon"><label v-if="!img1" >查看</label></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="proBox" @click="open(2)" @mouseenter="mouseEnter(2)" @mouseleave="mouseLeave(2)">
                  <div class="grid-content proCenter" >
                    <img v-if="img2" src="@/assets/images/pro2-1.png"/>
                    <img v-else src="@/assets/images/pro2-2.png"/>
                    <p class="title">案例库引用相符案例</p>
                    <p class="details" title="活动云平台提供千余种活动案例，助力机构免去文案编写，一键引用相符案例，通过修改部分文案就可完成活动的文字说明。">活动云平台提供千余种活动案例，助力机构免去文案编写，一键引用相符案例，通过修改部分文案就可完成活动的文字说明。</p>
                    <div class="lookIcon"><label v-if="!img2" >查看</label></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
              <div class="proBox" @click="open(3)" @mouseenter="mouseEnter(3)" @mouseleave="mouseLeave(3)">
                <div class="grid-content proCenter" >
                  <img v-if="img3" src="@/assets/images/pro3-1.png"/>
                  <img v-else src="@/assets/images/pro3-2.png"/>
                  <p class="title">一键发布活动至多终端</p>
                  <p class="details" title="你可以通过点击一键发布按钮，将配置的活动同步至pc端、微信端，多终端只需一次配置。">你可以通过点击一键发布按钮，将配置的活动同步至pc端、微信端，多终端只需一次配置。</p>
                  <div class="lookIcon"><label v-if="!img3" >查看</label></div>
                </div>
              </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-row :gutter="10">
              <el-col :span="12">
              <div class="proBox" @click="open(4)" @mouseenter="mouseEnter(4)" @mouseleave="mouseLeave(4)">
                <div class="grid-content proCenter" >
                  <img v-if="img4" src="@/assets/images/pro4-1.png"/>
                  <img v-else src="@/assets/images/pro4-2.png"/>
                  <p class="title">作品审核及优秀作品评选</p>
                  <p class="details" title="你可以对参赛作品进行审核，审核通过的作品可以进入优秀作品评审页。你可以在已通过审核的作品中筛选出优秀作品，并进行相应奖励发放">你可以对参赛作品进行审核，审核通过的作品可以进入优秀作品评审页。你可以在已通过审核的作品中筛选出优秀作品，并进行相应奖励发放</p>
                  <div class="lookIcon"><label v-if="!img4" >查看</label></div>
                </div>
              </div>
            </el-col>
              <el-col :span="12">
              <div class="proBox" @click="open(5)" @mouseenter="mouseEnter(5)" @mouseleave="mouseLeave(5)">
                <div class="grid-content proCenter" >
                  <img v-if="img5" src="@/assets/images/pro5-1.png"/>
                  <img v-else src="@/assets/images/pro5-2.png"/>
                  <p class="title">活动数据查看及数据导出</p>
                  <p class="details" title="活动云平台提供丰富的活动数据以及作品数据，可以一键追溯历史数据以及批量导出数据，供活动方分析数据">活动云平台提供丰富的活动数据以及作品数据，可以一键追溯历史数据以及批量导出数据，供活动方分析数据</p>
                  <div class="lookIcon"><label v-if="!img5" >查看</label></div>
                </div>
              </div>
            </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import IndexTitle from '@/components/IndexTitle'
   export default {
        name: 'HoldActivity',
        components: {
          IndexTitle
        },
        data() {
            return {
              img1:true,
              img2:true,
              img3:true,
              img4:true,
              img5:true,
            }
        },
        created() {
        },
        methods: {
           // 移入
           mouseEnter(num){
           switch(num){
             case 1:
              this.img1 = false
              break;
              case 2:
              this.img2 = false
              break;
              case 3:
              this.img3 = false
              break;
              case 4:
              this.img4 = false
              break;
              case 5:
              this.img5 = false
              break;
           }
          },
          mouseLeave(num){
           switch(num){
             case 1:
              this.img1 = true
              break;
              case 2:
              this.img2 = true
              break;
              case 3:
              this.img3 = true
              break;
              case 4:
              this.img4 = true
              break;
              case 5:
              this.img5 = true
              break;
           }
          },

          open(num){
            switch(num){
              // 素材库
             case 1:
              window.open("https://www.yulin365.net/manage/home/material-lib")
              break;
              case 2:
                // 案例库
              // window.open("https://www.yulin365.net/backend/activity/example/index")
              window.open(`https://www.yulin365.net/manage/home/case-lib`)
              break;
              case 3:
              // 我要办活动
              // window.open("https://www.yulin365.net/backend/activity/activity/edit")
              window.open(`https://www.yulin365.net/manage/home/activity`)
              break;
              case 4:
              // 作品管理
              // window.open('https://www.yulin365.net/backend/activity/activity-works/list')
              window.open(`https://www.yulin365.net/manage/home/activity`)
              break;
              case 5:
              // 整理数据
              // window.open('https://www.yulin365.net/backend/main/system_jg')
              window.open(`https://www.yulin365.net/manage/home/statistics`)
              break;
           }
          }
        }
    }
</script>
</script>
<style scoped>
  .process{
    width: 1200px;
    margin: 0 auto;
  }
  .proBox{
    width: 100%;
    height: 320px;
  }

  .proCenter{
    width: 100%;
    height: 280px;
    background: white;
    border-radius: 10px;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
  }
  .proCenter img{
    width: 56px;
    height: 56px;
  }
  .proCenter .title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #262626;
    margin: 25px 0px;
  }
  .proBox .lookIcon{
    width: 80%;
    text-align: center;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: -33px;

  }
  .proBox .lookIcon label{
    display: inline-block;
    width: 62px;
    height: 62px;
    line-height: 62px;
    text-align: center;
    background: #FFB463;
    box-shadow: 0px 2px 10px 0px rgba(181, 119, 52, 0.15);
    border-radius: 50%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .proCenter .details{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
    max-height: 90px;
    overflow: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .proCenter:hover{
    background: #3370ff;
    border-radius: none;
    transition: all 0.2s ease-in-out;
  }
  .proCenter:hover p{
    color: white;
    transition: all 0.2s ease-in-out;
  }

  @media (max-width: 1080px) {
    .proCenter .details{
      -webkit-line-clamp: 2;
    }
  }

</style>



// WEBPACK FOOTER //
// src/index/components/holdActivity.vue